module.exports = __webpack_public_path__ + "static/media/send.efc6bb91.svg";